import { render, staticRenderFns } from "./Memories.vue?vue&type=template&id=08c37ebe&scoped=true"
import script from "./Memories.vue?vue&type=script&lang=js"
export * from "./Memories.vue?vue&type=script&lang=js"
import style0 from "./Memories.vue?vue&type=style&index=0&id=08c37ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c37ebe",
  null
  
)

export default component.exports